<template>
	<button
		class="rounded-button group relative flex cursor-pointer items-center justify-center whitespace-nowrap border-2 font-bold uppercase transition-all duration-200 focus-visible:outline-0 disabled:cursor-auto"
		:class="[
			colorClasses,
			{
				'hover:bg-success-light hover:border-success-light disabled:bg-secondary disabled:border-secondary shadow-lg disabled:text-white':
					props.appearance === 'Primary',
				'disabled:bg-secondary disabled:border-secondary bg-transparent hover:text-white disabled:text-white':
					props.appearance === 'Outlined',
				'min-w-[10rem] py-1.5 px-4 text-base': props.size === 'Small',
				'min-w-[150px] py-3 px-7 text-base md:min-w-[280px] lg:py-3.5':
					props.size === 'Normal',
				'min-w-[220px] py-3 px-8 text-lg font-bold md:min-w-[320px] lg:py-4':
					props.size === 'Large',
				'bg-secondary border-secondary hover:bg-secondary hover:border-secondary':
					props.disabledTouched,
			},
		]"
		:disabled="disabled"
	>
		<slot />
	</button>
</template>

<script lang="ts" setup>
	import { computed } from 'vue'

	type ButtonAppearance = 'Primary' | 'Outlined'
	type ButtonSize = 'Small' | 'Normal' | 'Large'

	const props = withDefaults(
		defineProps<{
			appearance?: ButtonAppearance
			size?: ButtonSize
			disabled?: boolean
			disabledTouched?: boolean
			cta?: boolean
		}>(),
		{
			appearance: 'Primary',
			size: 'Normal',
			disabled: false,
			disabledTouched: false,
			cta: false,
		},
	)

	// computed
	const colorClasses = computed(() => {
		if (props.appearance === 'Primary') {
			if (props.cta) return 'bg-ctaColor border-ctaColor text-ctaTextColor'

			return 'bg-success-base border-success-base text-white'
		}

		if (props.appearance === 'Outlined') {
			if (props.cta)
				return 'border-ctaColor text-ctaTextColor hover:bg-ctaColor hover:border-ctaColor'

			return 'border-success-base text-success-base hover:bg-success-light hover:border-success-light'
		}

		if (props.appearance === 'Outlined') {
			if (props.cta)
				return 'border-ctaColor text-ctaTextColor hover:bg-ctaColor hover:border-ctaColor'

			return 'border-success-base text-success-base hover:bg-success-light hover:border-success-light'
		}
		return ''
	})
</script>
